import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AlertController, IonSelect } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { TieService } from '../../../_core/services/tie.service';
import { CollectionDefinition, Tie } from '../../../_shared/models/tie.model';
import { User } from '../../../_shared/models/user.model';
import { AuthService } from '../../../auth/auth.service';

@Component({
  standalone: false,
    selector: 'app-collection-header',
    templateUrl: './collection-header.component.html',
    styleUrls: ['./collection-header.component.scss'],
})
export class CollectionHeaderComponent {
    @ViewChild('select') select: IonSelect;
    @Input() collectionDefinition: CollectionDefinition;
    @Input() tie: Tie;
    @Input() canRemoveCollection: boolean;
    @Output() updateMatchGroup: EventEmitter<boolean> = new EventEmitter();

    canShowDeleteButton: boolean = false;

    constructor(
        private translateService: TranslateService,
        private alertController: AlertController,
        private tieService: TieService,
        private authService: AuthService,
    ) { }

    async ngOnChanges(changes: SimpleChanges) {
        const tieChange = changes['tie'];
        if (tieChange &&
            tieChange.previousValue !== tieChange.currentValue &&
            this.tie
        ) {
            const isAuthenticated = await this.authService.isAuthenticated();
            if (!isAuthenticated) {
                return;
            }
            const authUser: User = await this.authService.getAuthUser();
            const userId = authUser._id.toString();

            const isOwner = this.tie?.owners?.some(ownerId =>
                ownerId?.toString?.() === userId
            );

            const isTracker = this.tie?.trackers?.some(tracker =>
                tracker?.tracker?._id?.toString?.() === userId
            );
            const organisations = this.tie?.organisations || [];
            if (organisations.length === 0) {
                this.canShowDeleteButton = true;
            } else {
                const canRemove = organisations[0]?.allowRemoveCollectionDefinition === true;
                this.canShowDeleteButton = canRemove && (isOwner || isTracker);
            }
        }
    }

    deleteCollection() {
        this.translateService.get(['Delete collection', 'Are you sure that you want to delete this match collection?', 'Yes, delete', 'No, keep it']).subscribe(
            async translations => {

                const alert = await this.alertController.create({
                    header: translations['Delete collection'],
                    message: translations['Are you sure that you want to delete this match collection?'],
                    buttons: [
                        {
                            text: translations['Yes, delete'],
                            handler: () => {

                                const matchIds = this.getMatchIds();

                                this.tieService
                                    .removeCollectionDefinition(this.tie._id, this.collectionDefinition, matchIds)
                                    .subscribe(
                                        res => {
                                            const index = this.tie.tieFormat.collectionDefinitions.findIndex(cd => cd.collectionId === this.collectionDefinition.collectionId);
                                            this.tie.tieFormat.collectionDefinitions.splice(index, 1);
                                            this.updateMatchGroup.emit(true);
                                        },
                                        err => {
                                            //console.log(err);
                                        }
                                    );
                            }
                        },
                        {
                            text: translations['No, keep it']
                        }
                    ]
                });

                await alert.present();
            });
    }

    private getMatchIds() {
        const matchIds = [];
        this.tie.matchUps.forEach(match => {
            if (match.collectionId === this.collectionDefinition.collectionId) {
                matchIds.push(match._id);
            }
        });

        return matchIds;
    }




}
